var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "680" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("title", { name: _vm.dossierName }))),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        { style: { padding: "0 0 0 0" } },
        [
          _vm.loading
            ? _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { center: "" } },
                    [_c("w-progress-circular", { attrs: { large: "" } })],
                    1
                  ),
                ],
                1
              )
            : [
                !_vm.runs.length
                  ? _c("p", { staticClass: "empty" }, [
                      _vm._v(" " + _vm._s(_vm.$ct("empty")) + " "),
                    ])
                  : _c("div", { staticClass: "table-scroll" }, [
                      _c("table", { staticClass: "log-table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v(_vm._s(_vm.$ct("col.date")))]),
                            _c("th", [_vm._v(_vm._s(_vm.$ct("col.type")))]),
                            _c("th", [_vm._v(_vm._s(_vm.$ct("col.trigger")))]),
                            _c("th", { staticClass: "num" }, [
                              _vm._v(_vm._s(_vm.$ct("col.created"))),
                            ]),
                            _c("th", { staticClass: "num" }, [
                              _vm._v(_vm._s(_vm.$ct("col.skipped"))),
                            ]),
                            _c("th", { staticClass: "num" }, [
                              _vm._v(_vm._s(_vm.$ct("col.failed"))),
                            ]),
                            _c("th", { staticClass: "expand-col" }),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.runs, function (r, i) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    key: "r" + i,
                                    class: { "has-failed": r.Failed > 0 },
                                  },
                                  [
                                    _c("td", [
                                      _vm._v(_vm._s(_vm.formatDate(r.RunAt))),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.docLabel(r.DocumentType))
                                      ),
                                    ]),
                                    _c("td", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "badge",
                                          class:
                                            r.Trigger == "auto"
                                              ? "badge-auto"
                                              : "badge-manual",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.triggerLabel(r.Trigger)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("td", { staticClass: "num" }, [
                                      _vm._v(_vm._s(r.Created)),
                                    ]),
                                    _c("td", { staticClass: "num" }, [
                                      _vm._v(_vm._s(r.Skipped)),
                                    ]),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "num",
                                        class: { "failed-num": r.Failed > 0 },
                                      },
                                      [_vm._v(" " + _vm._s(r.Failed) + " ")]
                                    ),
                                    _c(
                                      "td",
                                      { staticClass: "expand-col" },
                                      [
                                        _vm.hasErrors(r)
                                          ? _c(
                                              "w-link",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggle(i)
                                                  },
                                                },
                                              },
                                              [
                                                _c("w-fa", {
                                                  attrs: {
                                                    icon:
                                                      _vm.expanded === i
                                                        ? "chevron-up"
                                                        : "chevron-down",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm.expanded === i && _vm.hasErrors(r)
                                  ? _c(
                                      "tr",
                                      {
                                        key: "e" + i,
                                        staticClass: "error-row",
                                      },
                                      [
                                        _c(
                                          "td",
                                          { attrs: { colspan: "7" } },
                                          _vm._l(
                                            _vm.parseErrors(r.Errors),
                                            function (e, j) {
                                              return _c(
                                                "div",
                                                {
                                                  key: j,
                                                  staticClass: "error-line",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "error-id" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          e.FriendlyID || "—"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "error-msg",
                                                    },
                                                    [_vm._v(_vm._s(e.Error))]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                _vm.runs.length >= 50
                  ? _c("p", { staticClass: "limit-hint" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$ct("limit-hint", { count: 50 })) + " "
                      ),
                    ])
                  : _vm._e(),
              ],
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("close")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }